/* global G */
import { setKey } from 'lib/util'
import validate from 'lib/hook/model/validate'
import sequenceComponentState from 'lib/sequence/component/state'
import find from 'lib/sequence/component/children/find'
import { disable, enable } from 'lib/sequence/component/state/disabled'
import { get, reset } from 'lib/sequence/component/state/value'

const {
  get: helperText,
  set: setHelperText,
} = sequenceComponentState('helperText')

const {
  get: error,
  set: setError,
} = sequenceComponentState('error')

/**
 * Intended to validate the serviceItem module's new and edit actions (i.e. those that use the form
 * ui config).
 *
 * It "bypasses" validating the serial field if it has already an error.
 *
 * @param {Gaia.AppModule.Spec} obj
 * @returns {function(...[*]): Promise<*[]>}
 */
const validateForm = obj => async (...args) => {
  const model = obj[G.MODEL]
  const actionComponent = obj[G.STATE][G.ACTION][G.COMPONENT]

  const { serial: serialValidator } = model[G.VALIDATOR]
  const { serial, name: nameField } = find(actionComponent)

  // If the serial field has already an error, we want it to stay
  const serialError = error(serial)
  const serialHelperText = helperText(serial)

  if (serialError) {
    disable(serialValidator)
  }

  // So that the value of the name field can be programmatically cleared, it has to be set to null
  // but, in this case, we consider null also an empty value, so we have to set it to undefined
  // for the notEmptyAttribute validator to throw an error
  if (get(nameField) === null) {
    reset(nameField)
  }

  const result = await validate(obj)(...args)

  // If the serial field had an error, we overwrite the state
  // set by the validation with its previous values
  if (serialError) {
    enable(serialValidator)
    setError(serial)
    setHelperText(serial, serialHelperText)
    setKey(true, G.ERROR, model[G.STATE])
  }

  return result
}

export default validateForm
